import { render, staticRenderFns } from "./floor2Dialog.vue?vue&type=template&id=0b4d7b35&scoped=true"
import script from "./floor2Dialog.vue?vue&type=script&lang=js"
export * from "./floor2Dialog.vue?vue&type=script&lang=js"
import style0 from "./floor2Dialog.vue?vue&type=style&index=0&id=0b4d7b35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d7b35",
  null
  
)

export default component.exports